import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'

import Section from '@/components/base/section'

import { cn } from '@/lib/utils'

const spacerVariants = cva(['border-0'], {
  variants: {
    variant: {
      xxs: 'pt-[0.8rem] md:pt-[1.6rem]',
      xs: 'pt-[1.6rem] md:pt-[3.2rem]',
      sm: 'pt-[2.4rem] md:pt-[4.8rem]',
      md: 'pt-[3.2rem] md:pt-[6.4rem]',
      lg: 'pt-[4rem] md:pt-[8rem]',
      xl: 'pt-[4.8rem] md:pt-[9.6rem]',
      xxl: 'pt-[5.6rem] md:pt-[11.2rem]'
    }
  },
  defaultVariants: {
    variant: 'md'
  }
})

export type SpacerProps = HTMLAttributes<HTMLHRElement> &
  VariantProps<typeof spacerVariants>

const Spacer = ({ className, variant, ...props }: SpacerProps) => {
  return (
    <Section
      asChild
      className={cn(spacerVariants({ variant, className }), 'relative z-0')}
      {...props}
    >
      <hr />
    </Section>
  )
}

export default Spacer
